export default __webpack_public_path__ + "static/terms-and-policies-generator-0-ec5e89bd410dab26bd797642ba97af81.png";